document.addEventListener('DOMContentLoaded', function () {
  const rateInput = document.getElementById('electric-rate');
  const tbody = document.querySelector('.energy-calculator tbody');
  const addRowButton = document.getElementById('add-row-btn');
  const resetButton = document.getElementById('reset-calculator-btn');

  if (!rateInput || !tbody || !addRowButton || !resetButton) {
    console.error('Energy calculator: required elements not found.');
    return;
  }

  function getRows() {
    return document.querySelectorAll('.energy-calculator tbody tr');
  }

  function calculateRow(row) {
    const wattage = parseFloat(row.querySelector('.wattage')?.value) || 0;
    const hours = parseFloat(row.querySelector('.hours')?.value) || 0;
    const months = parseFloat(row.querySelector('.months')?.value) || 0;
    const rate = parseFloat(rateInput.value) || 0;

    const kwhDay = (wattage * hours) / 1000;
    const kwhMonth = kwhDay * 30;
    const kwhYear = kwhDay * 365 * (months / 12);

    const costMonth = kwhMonth * rate;
    const costYear = kwhYear * rate;

    row.querySelector('.kwh-day').textContent = kwhDay.toFixed(2);
    row.querySelector('.kwh-month').textContent = kwhMonth.toFixed(2);
    row.querySelector('.kwh-year').textContent = kwhYear.toFixed(2);
    row.querySelector('.cost-month').textContent = costMonth.toFixed(2);
    row.querySelector('.cost-year').textContent = costYear.toFixed(2);
  }

  function calculateTotals() {
    let totalKwhDay = 0;
    let totalKwhMonth = 0;
    let totalKwhYear = 0;
    let totalCostMonth = 0;
    let totalCostYear = 0;

    getRows().forEach(function (row) {
      totalKwhDay += parseFloat(row.querySelector('.kwh-day').textContent) || 0;
      totalKwhMonth += parseFloat(row.querySelector('.kwh-month').textContent) || 0;
      totalKwhYear += parseFloat(row.querySelector('.kwh-year').textContent) || 0;
      totalCostMonth += parseFloat(row.querySelector('.cost-month').textContent) || 0;
      totalCostYear += parseFloat(row.querySelector('.cost-year').textContent) || 0;
    });

    document.getElementById('total-kwh-day').textContent = totalKwhDay.toFixed(2);
    document.getElementById('total-kwh-month').textContent = totalKwhMonth.toFixed(2);
    document.getElementById('total-kwh-year').textContent = totalKwhYear.toFixed(2);
    document.getElementById('total-cost-month').textContent = totalCostMonth.toFixed(2);
    document.getElementById('total-cost-year').textContent = totalCostYear.toFixed(2);
  }

  function updateCalculator() {
    getRows().forEach(calculateRow);
    calculateTotals();
  }

  function addCustomRow() {
    const newRow = document.createElement('tr');
    newRow.classList.add('custom-row');
    newRow.innerHTML = `
      <td class="component"><input type="text" class="component-name" value="Custom Component"></td>
      <td><input type="number" class="wattage" value="0.00" step="0.01"></td>
      <td><input type="number" class="hours" value="24" step="0.01"></td>
      <td><input type="number" class="months" value="12" step="0.01"></td>
      <td class="cost-month">0.00</td>
      <td class="cost-year">0.00</td>
      <td class="kwh-day">0.00</td>
      <td class="kwh-month">0.00</td>
      <td class="kwh-year">0.00</td>
    `;
    tbody.appendChild(newRow);
    updateCalculator();
  }

  function resetCalculator() {
    document.querySelectorAll('.energy-calculator tr:not(.custom-row) input.wattage').forEach(function (input) {
      input.value = '0.00';
    });

    document.querySelectorAll('.energy-calculator .custom-row').forEach(function (row) {
      row.remove();
    });

    rateInput.value = '0.12';
    updateCalculator();
  }

  document.addEventListener('input', function (e) {
    if (e.target.closest('.energy-calculator') && e.target.tagName === 'INPUT') {
      updateCalculator();
    }
  });

  addRowButton.addEventListener('click', addCustomRow);
  resetButton.addEventListener('click', resetCalculator);

  updateCalculator();

  window.addCustomRow = addCustomRow;
  window.resetCalculator = resetCalculator;
});